import React from 'react';
import PropTypes from 'prop-types';
import * as _ from 'lodash';

const ShortDescription = ({ title, text, withBorder }) => {
    if (!_.isEmpty(text)) {
        return (
            <div className={`${withBorder ? 'border-b-2 border-bluegray-200 py-32' : ''}`}>
                <h3 className="font-bold">{title}</h3>
                <p>{text}</p>
            </div>
        );
    }
    return null;
};

ShortDescription.propTypes = {
    text: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    withBorder: PropTypes.bool,
};

export default ShortDescription;
